<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><i></i> </p>
<p class="p4"><i>The author wishes to thank … </i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Mark Ziesing for his patience and supportiveness</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Nancy Collins for her Sympathy for the Devil</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Micky Perry again for her editorial help</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Julian for restoring some of my innocence</i></p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?0d108e01